export default __webpack_public_path__ + "static/media/CarImages.KigerMedium1.500f6576.jpg";